import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

/* ===============================
   TIMETABLE DAY APIs
================================ */

/**
 * Create a new timetable day
 * @param {{
 *   date: string,      // YYYY-MM-DD (admin local date)
 *   timeZone: string   // IANA timezone, e.g. "Asia/Kolkata"
 * }} data
 */
export const createTimetableDay = (data) =>
  api.post("/admin/timetable/create_timetable_day", {
    date: data.date,
    timeZone: data.timeZone,
  });

/**
 * Delete a timetable day
 * @param {number} dayId
 */
export const deleteTimetableDay = (dayId) =>
  api.delete(`/admin/timetable/delete_timetable_day/${dayId}`);

/**
 * Fetch all timetable days with sessions
 */
export const getAllTimetableDays = () =>
  api.get("/admin/timetable/get_all_timetable_day");

/* ===============================
   TIMETABLE SESSION APIs
================================ */

/**
 * Add session to a day
 * @param {number} dayId
 * @param {{
 *   topic: string,
 *   level: string,
 *   startTime: string,
 *   endTime: string,
 *   totalSlots: number,
 *   planId: number
 * }} data
 */
export const addSessionToDay = (dayId, data) =>
  api.post(`/admin/timetable/day/${dayId}/add_session`, data);

/**
 * Update a session
 * @param {number} sessionId
 * @param {{
 *   topic: string,
 *   level: string,
 *   startTime: string,
 *   endTime: string,
 *   totalSlots: number,
 *   planId: number
 * }} data
 */
export const updateSession = (sessionId, data) =>
  api.put(`/admin/timetable/update_session/${sessionId}`, data);

/**
 * Delete a session
 * @param {number} sessionId
 */
export const deleteSession = (sessionId) =>
  api.delete(`/admin/timetable/delete_session/${sessionId}`);

/**
 * Cancel a session (admin)
 */
export const cancelSession = (sessionId) =>
  api.put(`/admin/timetable/session/${sessionId}/cancel`);

/**
 * Change session time (admin)
 */
export const changeSessionTime = (sessionId, startTime, endTime) =>
  api.put(`/admin/timetable/session/${sessionId}/change-time`, null, {
    params: { startTime, endTime },
  });

export const getSessionCustomers = (sessionId) => {
  return api.get(`/admin/session_users/${sessionId}/customers`);
};

// Enhanced version with WhatsApp info
export const getSessionCustomersEnhanced = (sessionId) => {
  return api.get(`/admin/session_users/${sessionId}/customers-enhanced`);
};